var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04531 11.7963L9.80977 19.5021C10.132 19.8219 10.5574 20 11 20C11.4426 20 11.868 19.8219 12.1902 19.5021L19.9547 11.7963C21.2609 10.5036 22 8.69017 22 6.79454V6.52961C22 3.33673 19.8301 0.614326 16.8695 0.0890309C14.9102 -0.258121 12.9164 0.422479 11.5156 1.91158L11 2.45971L10.4844 1.91158C9.08359 0.422479 7.08984 -0.258121 5.13047 0.0890309C2.16992 0.614326 0 3.33673 0 6.52961V6.79454C0 8.69017 0.739062 10.5036 2.04531 11.7963Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSolid);
export default __webpack_public_path__ + "static/media/heart-solid.416bd06338d0be7d160c7ec6f585b572.svg";
export { ForwardRef as ReactComponent };